import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MicIcon from '@mui/icons-material/Mic';

import { LocalizationContext } from '../../App';

const LoupeSoundMeteringComponent = props => {

    const callbackHandler = props.callbackHandler;
    const currentItem = props.currentItem;

    const [ maximumLevel, setMaximumLevel ] = React.useState(-Infinity);
    const [ isRecording, setIsRecording ] = useState(false);
    const [ audioContext, setAudioContext ] = useState(null);
    const [ analyserNode, setAnalyserNode ] = useState(null);
    const [ streamSource, setStreamSource ] = useState(null);
    const [ reqId, setReqId ] = useState(null);

    const [ sumPeakLevel, setSumPeakLevel ] = useState(0);
    const [ totalMeasurements, setTotalMeasurements ] = useState(0);
    const [ averagePeak, setAveragePeak ] = useState(0);


    const [ startBtnEnabled, setStartBtnEnabled ] = useState(true);
    const [ stopBtnEnabled, setStopBtnEnabled ] = useState(false);

    var isActive = isRecording;
    var audioCtx = audioContext;
    var analyser = analyserNode;
    var source = streamSource;
    var maxLevel = maximumLevel;
    var currentMaxLevel = maximumLevel;    

    var soundData = [];
    var averageMean = 0;
    var avgi = 0;

    const update = () => {
        
        if(isActive == true) { 
            

            analyser.getFloatFrequencyData(soundData);
            //analyser.getByteFrequencyData(soundData);

            // var values = 0;
            // var average;

            // var length = soundData.length;

            // // get all the frequency amplitudes
            // for (var i = 0; i < length; i++) {
            //     values += (soundData[i] - analyser.minDecibels);
            // }
            // average = values / length;
           


            currentMaxLevel = Math.max.apply(Math, soundData) - analyser.minDecibels;           
            
            if( avgi < 50 ){
                
                averageMean += currentMaxLevel;
                avgi += 1;

            } else {

                var cMean = averageMean / avgi;
                console.log(cMean);

                var cSum = sumPeakLevel + cMean;                     
                var measurementCount = totalMeasurements + 1;

                setSumPeakLevel(cSum);
                setTotalMeasurements(measurementCount);
                setAveragePeak( (cSum/measurementCount) );

                avgi = 0;
                averageMean = 0;
            }
 

            if( maxLevel < currentMaxLevel ) {
                maxLevel = currentMaxLevel;                
                setMaximumLevel(maxLevel);
            }
            
            var id = requestAnimationFrame(update);
            setReqId(id);
        }
    }
    


    const startRecording = () => {

        isActive = true;
        setIsRecording(true);
        setStartBtnEnabled(false);
        setStopBtnEnabled(true);
        
        if (!navigator.mediaDevices) {
            alert("mediaDevices() not supported.");
            throw new Error("mediaDevices() not supported.")
        } else {

            navigator.mediaDevices.getUserMedia(
                {
                    audio: true
                }
            ).then(function(stream) {
    
                // legacy var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                audioCtx = new AudioContext();
                setAudioContext(audioCtx);

                
                source = audioCtx.createMediaStreamSource(stream);

                // create analyser
                analyser = audioCtx.createAnalyser();                                
                analyser.fftSize = 512;
                analyser.maxDecibels = 0;
                analyser.smoothingTimeConstant = 0.3;
                source.connect(analyser);
                
                soundData = new Float32Array(analyser.frequencyBinCount);
                //soundData = new Uint8Array(analyser.frequencyBinCount);
                
                setAnalyserNode(analyser);
                update();


            }).catch(function(err){
                console.log('Error occurred while initalizing audio input: ' +  err.toString());
            });

        }
        

        

    }

    const endRecording = () => {
        
        cancelAnimationFrame(reqId);
        isActive = false;
        setIsRecording(false);
        setStartBtnEnabled(true);
        setStopBtnEnabled(false);

        audioCtx.close();
    }

    const resetRecording = () => {

        setMaximumLevel(-Infinity);
        setTotalMeasurements(0);
        setAveragePeak(0);
        setSumPeakLevel(0);

        currentMaxLevel = -Infinity;

    }

    useEffect(() => {
        
    }, []);


    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

            <div className="text-start mb-4">
                
                <LoupeItemHeaderComponent currentItem={currentItem} />

                <Grid container>

                    <Grid item xs={12}>
                        { (maximumLevel == -Infinity) ? "Not recorded" : maximumLevel}
                    </Grid>

                    <Grid item xs={12}>
                        {averagePeak}
                    </Grid>

                    <Grid item xs={12}>
                        { isRecording ? ( 
                        <>
                            <MicIcon />
                        </> 
                    ) : (
                        <>
                            <p/>
                        </>
                    ) }
                    </Grid>

                </Grid>
                
                <Button onClick={startRecording} disabled={ (startBtnEnabled ? false : true) }  >Record</Button>
                <Button onClick={endRecording} disabled={ (stopBtnEnabled ? false : true) }>Stop</Button>
                <Button onClick={resetRecording}>Reset</Button>    

            </div>
            }
        </LocalizationContext.Consumer>
    );
}
export default LoupeSoundMeteringComponent;